import * as React from "react";

interface ChartIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: number | string;
}

export const ChartIcon = React.forwardRef<SVGSVGElement, ChartIconProps>(
  ({ className, size = 38, width, height, ...props }, ref) => (
          <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10.4C4 8.15979 4 7.03969 4.43597 6.18404C4.81947 5.43139 5.43139 4.81947 6.18404 4.43597C7.03969 4 8.15979 4 10.4 4H21.6C23.8402 4 24.9603 4 25.816 4.43597C26.5686 4.81947 27.1805 5.43139 27.564 6.18404C28 7.03969 28 8.15979 28 10.4V21.6C28 23.8402 28 24.9603 27.564 25.816C27.1805 26.5686 26.5686 27.1805 25.816 27.564C24.9603 28 23.8402 28 21.6 28H10.4C8.15979 28 7.03969 28 6.18404 27.564C5.43139 27.1805 4.81947 26.5686 4.43597 25.816C4 24.9603 4 23.8402 4 21.6V10.4ZM20 18.6667C20 17.9303 19.403 17.3333 18.6667 17.3333C17.9303 17.3333 17.3333 17.9303 17.3333 18.6667V24C17.3333 24.7364 17.9303 25.3333 18.6667 25.3333C19.403 25.3333 20 24.7364 20 24V18.6667ZM24 9.33333C24.7364 9.33333 25.3333 9.93029 25.3333 10.6667V24C25.3333 24.7364 24.7364 25.3333 24 25.3333C23.2636 25.3333 22.6667 24.7364 22.6667 24V10.6667C22.6667 9.93029 23.2636 9.33333 24 9.33333ZM14.6667 13.3333C14.6667 12.597 14.0697 12 13.3333 12C12.597 12 12 12.597 12 13.3333V24C12 24.7364 12.597 25.3333 13.3333 25.3333C14.0697 25.3333 14.6667 24.7364 14.6667 24V13.3333ZM8 6.66667C8.73638 6.66667 9.33333 7.26362 9.33333 8V24C9.33333 24.7364 8.73638 25.3333 8 25.3333C7.26362 25.3333 6.66667 24.7364 6.66667 24V8C6.66667 7.26362 7.26362 6.66667 8 6.66667Z"
        fill="currentColor"
      />
    </svg>
  )
);

ChartIcon.displayName = "ChartIcon";
